module.exports = [
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Caño de bañera",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "Eurocube",
		"subheadline": "Caño de bañera",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Desagüe automático con caño integrado",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Sistema de ducha con termostato",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "Sistema de ducha GROHE Euphoria XXL con termostato, acabado cromado y de diseño alemán, con ducha de techo metálica de 310 mm y teleducha de tres chorros de 110 mm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sistema de ducha con termostato",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "Sistema de ducha GROHE Euphoria Cube XXL 230 con termostato",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174000/640/26174000.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Conjunto de ducha con soporte 4 chorros",
		"textblock_1st_text": "26174000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26174000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26146000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26146000/640/26146000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha 422 mm",
		"textblock_1st_text": "26146000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26146000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Codo de salida de 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Soporte mural",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 sistema de ducha con termostato",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "Sistema de ducha con termostato GROHE Rainshower SmartControl 360 DUO Exposed. Ducha de techo de 360 mm cromada, respetuosa con el medioambiente y fabricada en Alemania, con chorro GROHE TrioMassage y teleducha de 115 mm con dos chorros.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Ducha lateral 1 chorro",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "Sistema de ducha con termostato GROHE Rainshower SmartControl 360 MONO Exposed. Cromado, respetuoso con el medioambiente y fabricado en Alemania: teleducha de 360 mm y ducha de techo de 115 mm con cuatro chorros.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Codo de salida de 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Codo de salida de ducha Eurocube con soporte de pared, acabado cromado y diseño alemán.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 sistema de ducha con termostato",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Soporte mural",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Caño de bañera",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema de ducha con termostato para baño ducha",
		"textblock_1st_text": "27641000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27711000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27711000/640/27711000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de techo 154 mm",
		"textblock_1st_text": "27711000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27711000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul Cosmopolitan con  teleducha (130 mm), barra de ducha (900 mm) y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27736000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27736000/640/27736000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27736000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha(130 mm), barra de ducha (600 mm) y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27736000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27732000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27732000/640/27732000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27732000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27732000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha (130 mm), barra de ducha (900 mm) y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Conjunto de ducha 2 chorros",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Conjunto de ducha 2 chorros",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha (115 mm), barra de ducha (900 mm) y flexo de ducha (1,750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barra de ducha de 60 cm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Barra de ducha de 90 cm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27838000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27838000/640/27838000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Conjunto de ducha con soporte, teleducha 2 chorros",
		"textblock_1st_text": "27838000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul Cosmopolitan con  teleducha (115 mm), flexo de ducha (1,250 mm) y soporte para teleducha",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27838000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27271000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27271000/640/27271000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "27271000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27271000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27477000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27477000/640/27477000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "27477000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27479000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27479000/640/27479000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "27479000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27479000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28778000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28778000/640/28778000.jpg",
		"headline": "Rainshower Cosmopolitan 400",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "28778000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28778000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Desagüe automático con caño integrado",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 sistema de ducha con termostato",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27488000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27488000/640/27488000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de 275 mm",
		"textblock_1st_text": "27488000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27488000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27485000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27485000/640/27485000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de techo de 142 mm",
		"textblock_1st_text": "27485000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27485000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Conjunto de barra de ducha 1 chorro",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Teleducha 1 chorro",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Sistema de ducha con termostato <br />y duchas laterales",
		"textblock_1st_text": "27374000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Teleducha 1 chorro",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Conjunto de barra de ducha 1 chorro",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Codo de salida de 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27705000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27705000/640/27705000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "27705000",
		"textblock_2nd_text": "Ducha de techo GROHE Euphoria Cube 150 fabricada en Alemania, con chorro Rain, acabado cromado, y función de ahorro de agua",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27746000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27746000/640/27746000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27746000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul Cosmopolitan con teleducha (160 mm), barra de ducha (900 mm) y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27746000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27748000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27748000/640/27748000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27748000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha (130 mm), barra de ducha (600 mm)y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27748000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Conjunto de ducha con barra 4 chorros",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha (160 mm), barra de ducha (900 mm)  y flexo de ducha (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27839000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27839000/640/27839000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Conjunto de ducha con soporte, teleducha 2 chorros",
		"textblock_1st_text": "27839000",
		"textblock_2nd_text": "Conjunto GROHE Power&Soul con teleducha  (115 mm), flexo de ducha (1,250 mm) y soporte para teleducha",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27839000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "Sistema de ducha GROHE Euphoria 210 con termostato",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34286002",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34286002/640/34286002.jpg",
		"headline": "Grohtherm 1000 Cosmopolitan M",
		"subheadline": "Termostato de ducha 1/2\"",
		"textblock_1st_text": "34286002",
		"textblock_2nd_text": "Termostato de ducha GROHE Grohtherm 1000 Cosmopolitan M con juego de ducha GROHE Euphoria 110 Massage, barra de ducha de 600 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34286002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G416",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34399000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34399000/640/34399000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set de ducha completo con Rainshower Cosmopolitan 160",
		"textblock_1st_text": "34399000",
		"textblock_2nd_text": "Cómodo conjunto de ducha GROHE Grohtherm 3000 Cosmopolitan, termostato empotrado incluido",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34399000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34408000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34408000/640/34408000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set de ducha completo con Rainshower 210",
		"textblock_1st_text": "34408000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34408000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Set de ducha con Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "Juego de ducha GROHE Grohtherm Cube Perfect con ducha de techo Rainshower Allure de 230 mm, teleducha Euphoria Cube y mezclador termostático Rapido T, para una instalación empotrada.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set de ducha completo con Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "Juego de ducha GROHE Grohtherm 3000 Cosmopolitan Perfect con ducha de techo Rainshower Cosmopolitan de metal de 310 mm, teleducha Sena y el mezclador termostático Rapido T, para una instalación empotrada.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Set de ducha completo con Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "Juego de ducha GROHE Grohtherm 3000 Cosmopolitan Perfect con ducha de techo Rainshower Cosmopolitan de metal de 310 mm, teleducha Sena y el mezclador termostático Rapido T, para una instalación empotrada.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Combinación perfecta de ducha con Rainshower Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "Juego de ducha GROHE Grohtherm 2000 Perfect con ducha de techo Rainshower Cosmopolitan de metal de 210 mm, teleducha Euphoria Cosmopolitan y mezclador termostático Rapido T, para una instalación empotrada.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27709000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27709000/640/27709000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de 286 mm",
		"textblock_1st_text": "27709000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27709000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28724000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28724000/640/28724000.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de techo de 142 mm",
		"textblock_1st_text": "28724000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28724000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexo de ducha Twistfree 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "Flexo GROHE SilverFlex con pieza de unión giratoria para la función TwistFree, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexo de ducha Twistfree 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "Flexo GROHE SilverFlex con pieza de unión giratoria para la función TwistFree, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368000/640/28368000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "28368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Flexo de ducha Twistfree 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "Flexo GROHE SilverFlex con pieza de unión giratoria para la función TwistFree, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema de ducha con termostato para baño ducha",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "Sistema de ducha GROHE Tempesta Cosmopolitan 210 con termostato para bañeras, ducha de techo de 210 mm y teleducha de 100 mm con dos chorros y acabado cromado. Fácil de instalar y limpiar. Diseño alemán",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema de ducha con monomando",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "Sistema de ducha GROHE Tempesta Cosmopolitan 210 con mezclador monomando, ducha de techo de 210 mm y teleducha de 100 mm con dos chorros y acabado cromado. Fácil de instalar y limpiar. Diseño alemán",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Sistema de ducha Flexible con inversor",
		"textblock_1st_text": "26381001",
		"textblock_2nd_text": "Sistema de ducha GROHE New Tempesta 210 FLEX con inversor; compatible con todas las válvulas existentes para reformas sencillas. Fabricado en Alemania, con ducha de techo de dos chorros de 210 m y teleducha de 100 mm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "Sistema de ducha GROHE Tempesta Cosmopolitan 210 con termostato, ducha de techo de 210 mm y teleducha de 100 mm con dos chorros y acabado cromado. Fácil de instalar y limpiar. De diseño alemán.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Conjunto de ducha mural con brazo 380 mm, 3 chorros",
		"textblock_1st_text": "26458000",
		"textblock_2nd_text": "Juego de ducha de techo GROHE Euphoria 260 SmartControl con tres zonas de chorro. Cabezal de ducha de 260 mm y brazo de techo (380 mm) GROHE Rainshower con acabado cromado. Fácil de instalar y limpiar. Producto fabricado en Alemania",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Conjunto de ducha con brazo de techo 142 mm, 3 chorros",
		"textblock_1st_text": "26460000",
		"textblock_2nd_text": "Juego de ducha de techo GROHE Euphoria 260 SmartControl con tres zonas de chorro. Cabezal de ducha de 260 mm y brazo de techo (142 mm) GROHE Rainshower con acabado cromado. Fácil de instalar y limpiar. Producto fabricado en Alemania",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Teleducha 4 chorros",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan 130, teleducha, más de cuatro chorros",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26146LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26146LS0/640/26146LS0.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha 422 mm",
		"textblock_1st_text": "26146LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26146LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28368LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28368LS0/640/28368LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Ducha mural",
		"textblock_1st_text": "28368LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28368LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28724LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28724LS0/640/28724LS0.jpg",
		"headline": "Rainshower",
		"subheadline": "Brazo de ducha de techo de 142 mm",
		"textblock_1st_text": "28724LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/28724LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Conjunto de ducha con brazo mural 380 mm, 1 chorro",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Ducha de techo con brazo 142 mm, 1 chorro",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower Cosmopolitan 310, juego de ducha de techo, brazo de ducha de 142 mm, 9,5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "Cuerpo empotrado Universal, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 1 llave",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha con instalación empotrada y una válvula. Forma redondeada, acabado cromado y fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha o baño con instalación empotrada y dos válvulas. Forma redondeada, acabado cromado y fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves y soporte de ducha integrado",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha o baño con instalación empotrada, dos válvulas y pieza de empalme para ducha integrada. Forma redondeada, acabado cromado y fabricado en Alemania por GROHE.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 3 llaves",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha o baño con instalación empotrada y tres válvulas. Forma redondeada, acabado cromado y fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 1 llave",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha con instalación empotrada y una válvula. Forma cuadrada, acabado cromado y fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha o baño con instalación empotrada y dos válvulas. Forma cuadrada, acabado cromado y fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves y soporte de ducha integrado",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha o baño con instalación empotrada, dos válvulas y pieza de empalme para ducha integrada. Forma cuadrada, acabado cromado y fabricado en Alemania por GROHE.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 3 llaves",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha o baño con instalación empotrada y tres válvulas. Forma cuadrada, acabado cromado y fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Combinación para la protección antiretorno (DIN-EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "Sistema de ducha con termostato GROHE Rainshower SmartControl 360 MONO Exposed. Cromado, respetuoso con el medioambiente y fabricado en Alemania: teleducha de 360 mm (placa de chorros blanca) y ducha de techo de 115 mm con cuatro chorros.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Combinación de Sistema de ducha con termostato, visto / empotrado",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "Sistema de ducha con termostato GROHE Rainshower SmartControl 360 Duo Combi. Cromado, respetuoso con el medioambiente y fabricado en Alemania: ducha de techo de 360 mm con chorro GROHE TrioMassage y teleducha de 115 mm con dos chorros.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Combinación de Sistema de ducha con termostato, visto / empotrado",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "Sistema de ducha con termostato GROHE Rainshower SmartControl 360 Duo Combi. Cromado, respetuoso con el medioambiente y fabricado en Alemania: ducha de techo de 360 mm con chorro GROHE TrioMassage y teleducha de 115 mm con dos chorros.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446000/640/26446000.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Combinación de Sistema de ducha con termostato, visto / empotrado",
		"textblock_1st_text": "26446000",
		"textblock_2nd_text": "Sistema de ducha con termostato GROHE Rainshower SmartControl 360 MONO Combi. Cromado, respetuoso con el medioambiente y fabricado en Alemania: teleducha de 360 mm y ducha de techo de 115 mm con cuatro chorros.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26446000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26446LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26446LS0/640/26446LS0.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Combinación de Sistema de ducha con termostato, visto / empotrado",
		"textblock_1st_text": "26446LS0",
		"textblock_2nd_text": "Sistema de ducha con termostato GROHE Rainshower SmartControl 360 MONO Combi. Cromado, respetuoso con el medioambiente y fabricado en Alemania: teleducha de 360 mm (placa de chorros blanca) y ducha de techo de 115 mm con cuatro chorros.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26446LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower Mono 360",
		"subheadline": "Conjunto de ducha mural con brazo 450 mm, 1 chorro",
		"textblock_1st_text": "26450000",
		"textblock_2nd_text": "Juego de ducha de techo GROHE Rainshower 360 MONO. Cromado, fabricado en Alemania: ducha de techo de 360 mm y brazo de ducha de 450 mm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Conjunto de ducha Perfect con Rainshower SmartActive 310",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Juego de ducha Grohtherm SmartControl Perfect con termostato, para instalación empotrada con tres válvulas, ducha de techo, teleducha, brazo de ducha y flexo. Forma redondeada. Acabado cromado, fabricado en Alemania.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Conjunto de ducha mural Perfect <br />con Rainshower SmartActive 310 Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Juego de ducha Grohtherm SmartControl Perfect con termostato, para instalación empotrada con tres válvulas, ducha de techo, teleducha, brazo de ducha y flexo. Forma cuadrada. Acabado cromado, fabricado en Alemania.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "Sistema de ducha con termostato GROHE Rainshower SmartControl 360 DUO Exposed. Ducha de techo de 360 mm cromada, respetuosa con el medioambiente y fabricada en Alemania con chorro GROHE TrioMassage y teleducha de 115 mm con, dos chorros.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Teleducha 2 chorros, cabezal en blanco",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Teleducha 4+ chorros, cabezal en blanco",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Caja empotrada para duchas murales 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23409000",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23409000/640/23409000.jpg",
		"headline": "Eurocube",
		"subheadline": "Perfecto Set de ducha con Euphoria Cube 152",
		"textblock_1st_text": "23409000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/23409000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G318",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combinación termostática de ducha con 3 salidas, visto/empotrado",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "Termostato de ducha GROHE Grohtherm SmartControl Combi con tres válvulas. Cromado con bandeja blanca, diseño alemán.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combinación termostática de ducha con 2 salidas, visto/empotrado",
		"textblock_1st_text": "34714000",
		"textblock_2nd_text": "Termostato de ducha GROHE Grohtherm SmartControl Combi con dos válvulas. Cromado con bandeja blanca, diseño alemán.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Cuerpo empotrado para variantes vistas/ empotradas",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower Mono 360",
		"subheadline": "Conjunto de ducha mural con brazo 450 mm, 1 chorro",
		"textblock_1st_text": "26450LS0",
		"textblock_2nd_text": "Juego de ducha de techo GROHE Rainshower 360 MONO. Cromado, fabricado en Alemania: ducha de techo de 360 mm (placa de chorros blanca) y brazo de ducha de 450 mm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Conjunto de ducha con termostato de ducha 1/2\"",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34565001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34565001/640/34565001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Conjunto de ducha con termostato de ducha 1/2\"",
		"textblock_1st_text": "34565001",
		"textblock_2nd_text": "Termostato de ducha Grohtherm 800 con juego con barra de ducha GROHE New Tempesta (que consta de una teleducha de 100 mm con dos opciones de chorro, una barra de ducha de 600 mm y un flexo de 1750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34565001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha o baño con instalación empotrada y dos válvulas. Forma cuadrada, Moon White, fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 3 llaves",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha o baño con instalación empotrada y tres válvulas. Forma cuadrada, Moon White, fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Conjunto de ducha mural 430 mm, 2 chorros",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "Juego de ducha de techo GROHE Rainshower 310 SmartActive con dos tipos de chorro. Cabeza de ducha de 310 mm, montaje en pared, brazo de ducha de 400 mm, acabado cromado, placa de chorros blanca y forma redondeada. Producto fabricado en Alemania",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Conjunto de ducha de techo con brazo 142 mm, 2 chorros",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "Juego de ducha de techo GROHE Rainshower 310 SmartActive con dos tipos de chorro. Cabeza de ducha de 310 mm, montaje en techo, brazo de ducha de 142 mm, acabado cromado, placa de chorros blanca y forma redondeada. Producto fabricado en Alemania",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Conjunto de ducha de techo con brazo 142 mm, 2 chorros",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "Juego de ducha de techo GROHE Rainshower 310 SmartActive con dos tipos de chorro. Cabeza de ducha de 310 mm, montaje en techo, brazo de ducha de 142 mm, acabado cromado, forma redondeada. Producto fabricado en Alemania",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Conjunto de ducha mural 430 mm, 2 chorros",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "Juego de ducha de techo GROHE Rainshower 310 SmartActive CUBE con dos tipos de chorro. Cabeza de ducha de 310 mm, montaje en pared, brazo de ducha de 400 mm, acabado cromado, placa de chorros blanca y forma cuadrada. Producto fabricado en Alemania",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Conjunto de ducha de techo con brazo 142 mm, 2 chorros",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "Juego de ducha de techo GROHE Rainshower 310 SmartActive CUBE con dos tipos de chorro. Cabeza de ducha de 310 mm, montaje en techo, brazo de ducha de 142 mm, acabado cromado, placa de chorros blanca y forma cuadrada. Producto fabricado en Alemania",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Conjunto de ducha de techo con brazo 142 mm, 2 chorros",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "Juego de ducha de techo GROHE Rainshower 310 SmartActive CUBE con dos tipos de chorro. Cabezal de ducha de 310 mm montado en el techo con brazo de ducha de 142 mm, acabado cromado y forma cuadrada. Producto fabricado en Alemania",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 1 llave",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha con instalación empotrada y una válvula. Forma redondeada, Moon White, fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 2 llaves",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha o baño con instalación empotrada y dos válvulas. Forma redondeada, Moon White, fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 3 llaves",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha o baño con instalación empotrada y tres válvulas. Forma redondeada, Moon White, fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Termostato empotrado con 1 llave",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Termostato Grohtherm SmartControl para ducha con instalación empotrada y una válvula. Forma cuadrada, Moon White, fabricado en Alemania por GROHE. Características de seguridad y respetuosas con el medioambiente",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Cuerpo empotrado Universal, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Conjunto de ducha con Tempesta 210",
		"textblock_1st_text": "34614001",
		"textblock_2nd_text": "Juego de ducha GROHE Grohtherm 1000 Perfect con ducha de techo de 210 mm y teleducha de 100 mm con dos chorros y acabado cromado.  Diseño alemán",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema de ducha <br />con termostato incorporado",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "Sistema de ducha GROHE Euphoria 260 con termostato, ducha de techo de 260 mm con tres chorros y teleducha de 110 mm con tres chorros y acabado cromado. Fácil de instalar y limpiar. Diseño alemán",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema de ducha con termostato para baño ducha",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "Sistema de bañera y ducha GROHE Euphoria 260 con termostato para bañeras, ducha de techo SmartControl de 260 mm con tres chorros y solución de ahorro de agua y teleducha de 110 mm con tres chorros y acabado cromado. Diseño alemán",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema de ducha con monomando",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "Sistema de ducha GROHE Euphoria 260 con mezclador monomando, ducha de techo SmartControl de 260 mm con solución de ahorro de agua y tres chorros y teleducha de 110 mm con tres chorros y acabado cromado. Diseño alemán",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Sistema de ducha con inversor",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "Sistema de ducha GROHE Euphoria 260 con inversor. Ducha de techo SmartControl de 260 mm con tres chorros con función de ahorro de agua y teleducha de 110 mm con tres chorros y acabado cromado. Producto fabricado en Alemania",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Conjunto de ducha con Tempesta 210",
		"textblock_1st_text": "25183001",
		"textblock_2nd_text": "Juego de ducha GROHE Eurosmart Cosmopolitan Perfect con mezclador monomando para instalación empotrada, ducha de techo de 210 mm y teleducha de 100 mm con dos chorros con acabado cromado.  Diseño alemán",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Sistema de ducha con monomando",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "Sistema de ducha GROHE Euphoria Cube XXL con mezclador monomando; acabado cromado y de diseño alemán, con ducha de techo de 230 mm y teleducha de un chorro.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.es/es_es/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.es/es_es/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_products_es_es.json
// module id = 828
// module chunks = 0